import { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { GuildContext } from '../../../utils/contexts/GuildContext';
import { MdSettings } from 'react-icons/md'
// import { FaRegListAlt } from 'react-icons/fa'
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import styles from './index.module.scss'

const MenuPage = () => {
  const { guild } = useContext(GuildContext);
  const navigate = useNavigate()
  
  return (
    <div className="page">
      <div className={styles.container}>
        <div className={styles.flex}>
          <h1>{guild?.name} - Categories</h1>
          <div onClick={() => navigate('/menu')}>
            <BsFillArrowLeftCircleFill size={35} color="#ffffff"/>
          </div>
        </div>
        {/* Basic Configurations */}
        <div className={styles.flex}>
          <h2>Basic Configuration</h2>
          <MdSettings size={35} color="#ffffff"/>
        </div>
        <div className={styles.grid}>
          <div className={styles.card}>
            <h3>Player Control</h3>
            <button onClick={() => navigate('/dashboard/control')} className={styles.button}>Toggle</button>
          </div>
          <div className={styles.card}>
            <h3>Server Language</h3>
            <button onClick={() => navigate('/dashboard/language')} className={styles.button}>Change</button>
          </div>
        </div>

        {/* Advanced Configurations */}
        {/* <div className={styles.flex}>
          <h2>Advanced Configuration</h2>
          <FaRegListAlt size={35} color="#ffffff"/>
        </div>
        <div className={styles.grid}>
          <div className={styles.card}>
            <h3>24/7 Mode</h3>
            <button onClick={() => navigate('/dashboard/247')} className={styles.button}>Toggle</button>
          </div>
          <div className={styles.card}>
            <h3>Request Channel</h3>
            <button onClick={() => navigate('/dashboard/request')} className={styles.button}>Config</button>
          </div>
        </div> */}
        
      </div>
    </div>
  )
}

export default MenuPage